import React from 'react';
import {useSelector} from 'react-redux';

const ModalsManager = () => {
  const modal = useSelector(state => state.ui.modal);

  let activeModal;

  switch (modal) {
    default:
      activeModal = null;
  }

  return <React.Fragment>{activeModal}</React.Fragment>;
};

export default ModalsManager;
